import { useCallback } from 'react'
import { PatientDetailsInput, PatientInput, PrivateUserDataInput } from 'src/graphql.generated'
import { useUpdatePatientMutation } from '../../advancedParticipant.generated'

// The mutation's `details` input names these `insuranceGroupID`/`insuranceMemberID`; the record reads
// them back as `groupID`/`memberID` (`update-patient.ts`'s read/write rename).
type PatientRecordDetailsInput = Omit<PatientDetailsInput, 'insuranceGroupID' | 'insuranceMemberID'> & {
  groupID?: string | null
  memberID?: string | null
}

export const useUpdatePatientRecord = (uid: string) => {
  const [updatePatient] = useUpdatePatientMutation()

  return useCallback(
    async (patient?: PatientInput, details?: PatientRecordDetailsInput, privateUserData?: PrivateUserDataInput) => {
      const { groupID: insuranceGroupID, memberID: insuranceMemberID, ...restDetails } = details ?? {}

      await updatePatient({
        variables: {
          uid,
          patient,
          details: details ? { ...restDetails, insuranceGroupID, insuranceMemberID } : undefined,
          privateUserData,
        },
      })
    },
    [uid, updatePatient]
  )
}
